import * as React from 'react'
import styled from '@emotion/styled'

const StyledSpan = styled(`span`)`
  display: inline-block;
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1;
  padding: 0;
  border: 0;
`

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
}

const VisuallyHidden: React.FC<Props> = ({ children, ...delegated }) => {
  const [forceShow, setForceShow] = React.useState(false)
  React.useEffect(() => {
    if (process.env.NODE_ENV !== `production`) {
      const handleKeyDown = (ev: KeyboardEvent) => {
        if (ev.code === `AltRight` || ev.code === `ControlRight`) {
          setForceShow(true)
        }
      }
      const handleKeyUp = (ev: KeyboardEvent) => {
        if (ev.code === `AltRight` || ev.code === `ControlRight`) {
          setForceShow(false)
        }
      }
      window.addEventListener(`keydown`, handleKeyDown)
      window.addEventListener(`keyup`, handleKeyUp)
      return () => {
        window.removeEventListener(`keydown`, handleKeyDown)
        window.removeEventListener(`keydown`, handleKeyUp)
      }
    }
  }, [])
  if (forceShow) {
    return <span>{children}</span>
  }
  return <StyledSpan {...delegated}>{children}</StyledSpan>
}

export default VisuallyHidden
